/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class TitleService {
    private planurl: string = environment.host + '/plan';
    private getParticipantUrl: string = environment.host + '/participantstatus?tabType=' + 'TRTAB';
    private leaderRules = [];
    private baseTitleTypesUrl: string = environment.host;

    constructor(private http: HttpClient) {}

    public getAllClassesAndPeriodsTabType() {
        return this.http.get(this.baseTitleTypesUrl.toString() + '/titleclasses?tabType=titleClass/titlerule').toPromise();
    }
      
    public getAllPlanVolumeDefinitionsTabType(planId: any) {
        const plan = this.planurl.toString()+ '/' + planId + '/volume-definitions?tabType=' + 'volumeconfigurationview/titlesrules';
        return this.http.get(plan).toPromise();
    }
      
    public getAllTitleTypes() {
        return this.http.get(this.baseTitleTypesUrl.toString() + '/titletypes?tabType=' + 'titletypesPage/titlerules').toPromise();
    }

    public getAllTitles(planId: any) {
        const titleurl = this.planurl.toString() + '/' + planId + '/title';
        return this.http.get(titleurl).toPromise();
    }

    public getAllTitlesTabType(planId: any) {
        const titleurl = this.planurl.toString() + '/' + planId + '/title?tabType=' + 'titlesview';
        return this.http.get(titleurl).toPromise();
    }

    public bulkUpdate(titleData: any, planId: any) {
        const titlesurl = this.planurl.toString() + '/' + planId + '/titles';
        return this.http.put(titlesurl, titleData).toPromise();
    }

    public getAllTitleLevels(planId: any) {
        const titleurl = this.planurl.toString() + '/' + planId + '/levels';
        return this.http.get(titleurl).toPromise();
    }

    public bulkLevelUpdate(titleData: any, planId: any) {
        const titlesurl = this.planurl.toString() + '/' + planId + '/levels';
        return this.http.put(titlesurl, titleData).toPromise();
    }

    public getLeaderRules() {
        return this.leaderRules;
    }

    public setLeaderRules(items: any) {
        this.leaderRules = items;
    }

    getAllOverrides() {
        return this.http.get(environment.host + '/overrides?tabType=overridePage/titlerules'.toString()).toPromise();
    }

    public getPlanMetadata(){
        const planMetaDataURL = this.planurl.toString() + '/metadata';
        return this.http.get(planMetaDataURL).toPromise();
    }

    public getAllParticipantStatus() {
        return this.http.get(this.getParticipantUrl.toString()).toPromise();
    }

    // getTrainings() {
    //     const url = environment.host + '/trainingProgram';
    //     return this.http.get(url).toPromise();
    // }

    // getCPPeriodTypes() {
    //     const url = environment.host + '/challengeProgram/periodType';
    //     return this.http.get(url).toPromise();
    // }

    public getCompanyGenConfiguration(companyId: any) {
        return this.http.get(environment.host+'/company/' + companyId + '/configuration').toPromise();
    }

    public getCompanyGenConfigurationTabType(companyId: any) {
        return this.http.get(environment.host+'/company/' + companyId + '/configuration?tabType=' + 'lineageconfiguration/titlerules').toPromise();
    }

    public getChallengeProgramMetaData(planId: number) {
        const url = environment.host + '/challengeProgram/' + planId;
        return this.http.get(url.toString()).toPromise();
    }

    public getChallengeProgramMetaDataTabType(planId: number) {
        const url = environment.host + '/challengeProgram/' + planId + '?tabType=challengeprogramview/titlesrules';
        return this.http.get(url.toString()).toPromise();
    }

    public getPromotionProgramMetaData() {
        const url = environment.host + '/challengeProgramMetadata';
        return this.http.get(url.toString()).toPromise();
    }

    public getPromotionProgramMetaDataTabType() {
        const url = environment.host + '/challengeProgramMetadata?tabType=challengeprogrammetadata/titlesrules';
        return this.http.get(url.toString()).toPromise();
    }

    public getCalendarDefinitionsMetaData(companyCode: string) {
        const url = environment.host + '/calendarDefinition?companyCode=' + companyCode;
        return this.http.get(url.toString()).toPromise();
    }

    public getCalendarDefinitionsMetaDataTabType(companyCode: string) {
        const url = environment.host + '/calendarDefinition?companyCode=' + companyCode + '&tabType=' + 'planperiodview/titlesrules';
        return this.http.get(url.toString()).toPromise();
    }

    public getMetricData(){
        const url = environment.host + '/metric-definitions';
        return this.http.get(url.toString()).toPromise();
    }
}
